<template>
  <v-container class="mt-12 pt-8" style="background: #fafafa;">
		<v-row style="background: #fafafa;">
			<v-col cols="12" class="mx-auto" PANNELS>
				<v-card :loading="loading">
					<v-card-title :class="`${arabic ? 'arFont' : 'enFont'}`">
						{{ i18n.appointments_calendar }}
					</v-card-title>
          <v-card-text :class="`${arabic ? 'arFont' : 'enFont'}`">
            <v-sheet height="64">
              <v-toolbar
                flat
                style="flex-direction: row-reverse;"
              >
                <v-btn
                  outlined
                  class="mr-4"
                  color="grey darken-2"
                  @click="setToday"
                >
                  {{ i18n.today }}
                </v-btn>
                <v-btn
                  fab
                  text
                  small
                  color="grey darken-2"
                  @click="next"
                >
                  <v-icon small>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
                <v-btn
                  fab
                  text
                  small
                  color="grey darken-2"
                  @click="prev"
                >
                  <v-icon small>
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
                <v-toolbar-title v-if="$refs.calendar">
                  {{ $refs.calendar.title }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-menu
                  bottom
                  right
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      outlined
                      color="grey darken-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <span>{{ i18n[type] }}</span>
                      <v-icon right>
                        mdi-menu-down
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="type = 'day'">
                      <v-list-item-title>{{ i18n.day }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'week'">
                      <v-list-item-title>{{ i18n.week }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'month'">
                      <v-list-item-title>{{ i18n.month }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
            </v-sheet>
            <v-sheet height="600">
              <v-calendar
                ref="calendar"
                v-model="focus"
                color="primary"
                :events="events"
                :event-color="getEventColor"
                :type="type"
                @click:event="showEvent"
                @click:more="viewDay"
                @click:date="viewDay"
                @change="updateRange"
              ></v-calendar>

              <CandidateAppointmentDialog :selectedElement="selectedElement" :selectedEvent="selectedEvent" :selectedOpen="selectedOpen" @close="selectedOpen = false" />
            </v-sheet>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { format } from 'timeago.js';
import CandidateAppointmentDialog from '@/components/candidateAppointmentDialog.vue';

export default {
  components: {
    CandidateAppointmentDialog
},
	data() {
		return {
			loading: false,
			resourceSettings: {
				resourceName: null,
				search: false,
				create: false,
				pagination: true,
			},
			resource: [],
      focus: '',
      type: 'month',
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
		}
	},
	computed: {
		user() {
			return this.$store.state.user
		},
		language() {
			return this.$store.state.language
		},
		i18n() {
			return this.$store.state.i18n[this.$store.state.language]
		},
		arabic() {
			if (this.$store.state.language == 'ar') return true
		},
	},
  async mounted () {
    await this.init()
    this.$refs.calendar.checkChange()
  },
  methods: {
		async loadResource() {
      return new Promise(async (res, rej) => {
        this.resource = await this.$store.dispatch('getResource', { resource: '/appointments' })
        res()
      })
		},
		async init() {
      this.loading = true
      await this.loadResource()
      this.loading = false
		},
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor (event) {
      return event.color
    },
    setToday () {
      this.focus = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    updateRange ({ start, end }) {
      const {data} = this.resource
      const events = []
      if (data) {
        for (let i = 0; i < data.length; i++) {
          events.push({
            id: data[i].id,
            evaluation: data[i].evaluation,
            interview: data[i].interview,
            employee_name: data[i].employee_name,
            employee_name: data[i].employee_name,
            name: data[i].interview ? 'interview' : 'evaluation',
            start: data[i].appointment,
            color: this.colors[this.rnd(0, this.colors.length - 1)],
            timed: true
          })
        }
      }

      this.events = events
    },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
  },
}
</script>